import React from 'react';
import { Link } from 'react-router-dom';


const LegalLayout = ({ title, children, lastUpdated }) => {
  return (
    <div className="min-h-screen bg-white font-poppins text-[#1a1a1a] pb-20">
      {/* Navigation / Header */}


      {/* Main Content Area */}
      <article className="max-w-3xl pt-[100px] lg:pt-[150px] mx-auto px-6">
        <header className="mb-12 border-b border-gray-50 pb-8">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight">
            {title}
          </h1>
          <div className="flex items-center gap-2">
            <span className="w-8 h-[2px] bg-[#3EBAA2]"></span>
            <p className="text-gray-400 text-sm font-medium">
              Last Updated: {lastUpdated}
            </p>
          </div>
        </header>
        
        {/* This div handles the spacing between the sections you paste in */}
        <div className="space-y-10 text-[16px] leading-[1.8] text-gray-700">
          {children}
        </div>

        {/* Support Footer */}
        <footer className="mt-20 pt-10 border-t border-gray-100 text-center">
          <p className="text-gray-400 text-sm">
            Questions regarding our legal terms? Reach out to 
            <a href="mailto:support@sitemanifest.com" className="ml-1 text-[#3EBAA2] font-semibold underline">
              support@sitemanifest.com
            </a>
          </p>
        </footer>
      </article>
    </div>
  );
};

export default LegalLayout;